import { render, staticRenderFns } from "./chooseDocument.vue?vue&type=template&id=5834cf04&scoped=true&"
import script from "./chooseDocument.vue?vue&type=script&lang=js&"
export * from "./chooseDocument.vue?vue&type=script&lang=js&"
import style0 from "./chooseDocument.vue?vue&type=style&index=0&id=5834cf04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5834cf04",
  null
  
)

export default component.exports